import { render } from "./RodasepNosotros.vue?vue&type=template&id=4004696d&scoped=true"
import script from "./RodasepNosotros.vue?vue&type=script&lang=js"
export * from "./RodasepNosotros.vue?vue&type=script&lang=js"

import "./RodasepNosotros.vue?vue&type=style&index=0&id=4004696d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4004696d"]])

export default __exports__